import React, { useState } from 'react'
import { useKurbanReportUIContext } from '../KurbanReportUIContext';
import * as actions from '../../_redux/report/kurbanReportAction';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardHeader, CardHeaderTitle, CardHeaderToolbar } from '../../../../../../../_metronic/_partials/controls'
import Divider from '@material-ui/core/Divider';
import DividerWithText from './DividerWithText';
import { tipeHewan, KurbanReportStatusBadge } from '../KurbanReportUIHelpers';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import { CertURL } from '../../../../../../config/UrlEndPoint';

function KurbanReportDetailCardInfo({ detailKurban }) {
  const history = useHistory();
  
  const tipeHewanDeterminer = (type) => {
    const foundType = tipeHewan.find((item) => item.value == type)
    if (foundType) {
      return foundType.text
    } else {
      return ""
    }
  }

  const doniColumns = [
    {
      dataField: "uuid",
      text: "NO",
      formatter: (_, __, rowIndex) => {
        return <span>{rowIndex + 1}</span>
      }
    },
    {
      dataField: "uuid",
      text: "Nama",
      formatter: (_, row) => {
        const nameKeys = Object.keys(row).filter((key) => /name_\d+/.test(key));

        return (
          <>
            {nameKeys.map((name, index) => (
              <div key={index}>
              {row[name] && (
                <>
                <span className='mr-2'>{index + 1}.</span>
                <span>{row[name]}</span>
                </>
              )}
              </div>
            ))}
          </>
        )
      }
    },
    {
      dataField: "uuid",
      text: "Sertifikat",
      formatter: () => {
        return (
          <a target={"_blank"} ref="noreferrer" href={`${CertURL}${detailKurban.uuid}/sertifikat-kurban.pdf`}>Sertifikat</a>
        )
      } 
    }
  ]
  
  return (
    <>
      <CardHeader title="Detail Kurban">
        <CardHeaderToolbar>
          <Button variant="secondary" onClick={() => history.goBack()}>Kembali</Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className='row'>
          <div className='col-12'>
            <h3>Kurban <span className='text-primary'>#{detailKurban.kurban_hid}</span></h3>
            <h4>
              <span style={{ fontSize: 14 }}>status</span> {" "}
              <span
                className={KurbanReportStatusBadge[detailKurban.status] && `badge badge-${KurbanReportStatusBadge[detailKurban.status]['type']}`}
              >
                {KurbanReportStatusBadge[detailKurban.status] && KurbanReportStatusBadge[detailKurban.status]['text']}
              </span>
            </h4>
          </div>
          <div className='col-12'>
            <DividerWithText>
              Detail Kurban
            </DividerWithText>
          </div>
          <div className='col-md-6'>
            <table className="table table-hover table-borderless">
              <tbody>
                <tr className='d-flex'>
                  <td className='col-6'>Nama Hewan</td>
                  <td className='col-6'>{detailKurban.thk_livestock.name}</td>
                </tr>
                <tr className='d-flex'>
                  <td className='col-6'>Tipe Hewan</td>
                  <td className='col-6'>{detailKurban.thk_livestock && tipeHewanDeterminer(detailKurban.thk_livestock.type)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='col-md-6'>
            <table className="table table-hover table-borderless">
              <tbody>
                <tr className='d-flex'>
                  <td className='col-6'>Nama Mitra</td>
                  <td className='col-6'>{detailKurban.thk_partner ? detailKurban.thk_partner.name : ""}</td>
                </tr>
                <tr className='d-flex'>
                  <td className='col-6'>Merging</td>
                  <td className='col-6'>{detailKurban.thk_kurban ? "Iya" : "Tidak"}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='col-12'>
            <DividerWithText>
              Atas Nama
            </DividerWithText>
          </div>
          <div className='col-12'>
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="uuid"
              data={detailKurban.donation_item ?? []}
              columns={doniColumns}
            >
            </BootstrapTable>
          </div>
        </div>
      </CardBody>
    </>
  )
}

export default KurbanReportDetailCardInfo